import {
  SubTrayItemProductDetails,
  TrayImageRecord,
} from 'lib/services/api/product-service/receiveItems/types'

/**
 * Updates the tray image history with a new image
 *
 * @param trayDetails The existing tray product details
 * @param imageUrl The URL of the new image
 * @param userEmail The email of the user adding the image
 * @param userRole The role of the user (rep, spd, or nurse)
 * @returns The updated tray product details
 */
export const updateTrayImageHistory = (
  trayDetails: SubTrayItemProductDetails,
  imageUrl: string,
  userEmail: string,
  userRole: 'rep' | 'spd' | 'nurse'
): SubTrayItemProductDetails => {
  const currentTimestamp = new Date()

  // Create the new image record
  const newImageRecord: TrayImageRecord = {
    imageUrl,
    addedBy: {
      email: userEmail,
      role: userRole,
    },
    timestamp: currentTimestamp,
  }

  // Initialize or update the tray image history
  const updatedTrayDetails = { ...trayDetails }

  // Always update the legacy trayImg field for backward compatibility
  updatedTrayDetails.trayImg = imageUrl

  // If trayImageHistory doesn't exist yet, create it
  if (!updatedTrayDetails.trayImageHistory) {
    updatedTrayDetails.trayImageHistory = {
      records: [newImageRecord],
      latest: {
        [userRole]: newImageRecord,
      },
    }
  } else {
    // Add the new record to the history
    updatedTrayDetails.trayImageHistory.records = [
      ...updatedTrayDetails.trayImageHistory.records,
      newImageRecord,
    ]

    // Update the latest image for this role
    updatedTrayDetails.trayImageHistory.latest = {
      ...updatedTrayDetails.trayImageHistory.latest,
      [userRole]: newImageRecord,
    }
  }

  return updatedTrayDetails
}
